import AhmadAhmadLocales from "@/data/localization/AboutAhmad.locales";
import {
  Body,
  FlexContainer,
  Heading1,
  Heading2,
  LI,
  Section,
  SectionArticle,
  Span,
  UL,
  useLocales,
} from "@crescentapplications/react-ui";

export default function Profile() {
  const l = useLocales();

  return (
    <Section bgColor="frame" id="profile" padding="lg">
      <FlexContainer direction="column" gap="xl" fullWidth>
        <Heading1>{l(AhmadAhmadLocales.profile)}</Heading1>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.biography)}</Heading2>
          <FlexContainer align="start" direction="column" gap="md">
            <Body>{l(AhmadAhmadLocales.biographyText1)}</Body>
            <Body>{l(AhmadAhmadLocales.biographyText2)}</Body>
            <Body>{l(AhmadAhmadLocales.biographyText3)}</Body>
          </FlexContainer>
        </SectionArticle>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.nameAndBirth)}</Heading2>
          <UL>
            <LI>
              <Span fontWeight={600}>{l(AhmadAhmadLocales.name)}</Span>{" "}
              {l(AhmadAhmadLocales.profileName)}
            </LI>
            <LI>
              <Span fontWeight={600}>{l(AhmadAhmadLocales.birthDate)}</Span>{" "}
              {l(AhmadAhmadLocales.profileBirthDate)}
            </LI>
            <LI>
              <Span fontWeight={600}>{l(AhmadAhmadLocales.birthPlace)}</Span>{" "}
              {l(AhmadAhmadLocales.profileBirthPlace)}
            </LI>
          </UL>
        </SectionArticle>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.family)}</Heading2>
          <UL>
            <LI>
              <Span fontWeight={600}>{l(AhmadAhmadLocales.marriage)}</Span>{" "}
              {l(AhmadAhmadLocales.marriageText)}
            </LI>
            <LI>
              <Span fontWeight={600}>{l(AhmadAhmadLocales.spouse)}</Span>{" "}
              {l(AhmadAhmadLocales.spouseText)}
            </LI>
            <LI>
              <Span fontWeight={600}>{l(AhmadAhmadLocales.siblings)}</Span>{" "}
              {l(AhmadAhmadLocales.siblingsText)}
            </LI>
          </UL>
        </SectionArticle>

        <SectionArticle bgColor="overlay" gap="sm">
          <Heading2>{l(AhmadAhmadLocales.citizenshipAndResidency)}</Heading2>
          <UL>
            <LI>
              <Span fontWeight={600}>{l(AhmadAhmadLocales.citizenship)}</Span>{" "}
              {l(AhmadAhmadLocales.citizenshipText)}
            </LI>
            <LI>
              <Span fontWeight={600}>
                {l(AhmadAhmadLocales.currentResidence)}
              </Span>{" "}
              {l(AhmadAhmadLocales.currentResidenceText)}
            </LI>
            <LI>
              <Span fontWeight={600}>
                {l(AhmadAhmadLocales.formerResidence)}
              </Span>{" "}
              {l(AhmadAhmadLocales.formerResidenceText)}
            </LI>
          </UL>
        </SectionArticle>
      </FlexContainer>
    </Section>
  );
}
